var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.$auth.user)?_c('Main'):_c('LoginForm',{attrs:{"errorMessage":_vm.errorMessage},on:{"submit":_vm.login}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }